import { render, staticRenderFns } from "./InvoiceRelatedEntryDialog.vue?vue&type=template&id=10bbbfd0&"
import script from "./InvoiceRelatedEntryDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceRelatedEntryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports